import React from 'react';
import { Link } from 'react-router-dom';
import TekyuLogo from './TekyuLogo';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen app-shell app-ambient">
      <div className="app-content mx-auto w-full max-w-4xl px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <div className="text-center mb-10">
          <Link to="/dashboard">
            <TekyuLogo className="h-16 w-auto mx-auto mb-6" />
          </Link>
          <h1 className="text-4xl font-extrabold text-white mb-4">Privacy Policy</h1>
          <p className="text-slate-400">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="prose prose-invert max-w-none space-y-6 text-slate-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Introduction</h2>
            <p>
              Tekyu ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, 
              use, disclose, and safeguard your information when you use our Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Information We Collect</h2>
            <p><strong>Personal Information:</strong></p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Email address (for account creation and communication)</li>
              <li>Name and profile information (if provided)</li>
              <li>Authentication credentials (managed securely via AWS Cognito)</li>
            </ul>
            <p className="mt-4"><strong>Usage Data:</strong></p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Roadmap preferences and selections</li>
              <li>Project progress and completion data</li>
              <li>Subscription status and payment information (processed securely via Stripe)</li>
              <li>Device and browser information</li>
              <li>IP address and location data</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. How We Use Your Information</h2>
            <p>We use collected information to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Provide and maintain the Service</li>
              <li>Generate personalized roadmaps</li>
              <li>Process payments and manage subscriptions</li>
              <li>Send important service updates</li>
              <li>Improve and optimize the Service</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Data Storage and Security</h2>
            <p>
              Your data is stored securely using AWS services (Cognito, AppSync, DataStore). We implement industry-standard 
              security measures including encryption, secure authentication, and access controls.
            </p>
            <p>
              Payment information is processed by Stripe and is not stored on our servers. We only receive confirmation of 
              successful payments.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Data Sharing and Disclosure</h2>
            <p>We do not sell your personal information. We may share data only:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>With service providers (AWS, Stripe) necessary to operate the Service</li>
              <li>When required by law or legal process</li>
              <li>To protect our rights and safety</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Cookies and Tracking</h2>
            <p>
              We use cookies and similar technologies to enhance your experience, analyze usage, and assist in marketing efforts. 
              You can control cookie preferences through your browser settings.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Your Rights (GDPR Compliance)</h2>
            <p>If you are in the EU, you have the right to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Access your personal data</li>
              <li>Rectify inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Data portability</li>
              <li>Withdraw consent</li>
            </ul>
            <p className="mt-4">To exercise these rights, contact us through the Service support channels.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Data Retention</h2>
            <p>
              We retain your data for as long as your account is active or as needed to provide the Service. 
              You may request deletion of your account and associated data at any time.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Children's Privacy</h2>
            <p>
              Our Service is not intended for users under 18 years of age. We do not knowingly collect information from children.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. International Data Transfers</h2>
            <p>
              Your data may be transferred to and processed in countries outside your jurisdiction. We ensure appropriate 
              safeguards are in place for such transfers.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">11. Changes to Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of significant changes via email or 
              through the Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">12. Contact Us</h2>
            <p>
              For privacy-related questions or to exercise your rights, please contact us through the support channels 
              provided in the Service.
            </p>
          </section>
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-2 text-green-400 hover:text-green-300 transition-colors"
          >
            ← Back to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
